<template>
    <span
        class="position--relative"
        :class="{
            'pointer bold--hover': header.canSort,
            'bold': fieldIsInQuery( header.filterName ),
            'disable': helpers.hasOwnProperty( 'id' )
        }"
        @click="orderByColumn( header ) "
    >
        {{ $t(`global.${ header.name || header }`) }}

        <template v-if="header.canSort">
            <icon-sort
                class="sort__arrow-down position--absolute"
                :class="{ 'sort__arrow-down--active': fieldIsInQuery(header.filterName) && $route.query.direction === 'desc' }"
            />
            <icon-sort
                class="sort__arrow-up position--absolute"
                :class="{ 'sort__arrow-up--active': fieldIsInQuery(header.filterName) && $route.query.direction === 'asc'  }"
            />
        </template>
    </span>
</template>

<script>
// store
import { mapState } from '@/hooks/use-store';

export default {
    components: {
        IconSort: () => import( /* webpackChunkName: 'IconSort' */ '@/components/bundles/layout/images/icons/IconSort' )
    },
    props: {
        header: Object
    },
    setup ( _, { root: { $route, $router } }) {
        const helpers = mapState({ module: 'storePayload', key: 'helpers' });

        /**
         * [method]
         * Função que ordena uma coluna de uma tabela de forma ascendente
         * ou descendente.
         *
        */
        const orderByColumn = header => {
            // Impede execução da função se a coluna não puder ser ordenada.
            if ( !header.canSort )
                return;

            const query = { ...$route.query };

            // São apagados os parametros 'sort' e 'direction' se tiverem na query
            // ( parametros relacionados com a ordenação da tabela ),
            delete query.sort;
            delete query.direction;

            // O sort vai ser a coluna clicada pelo utilizador.
            const sort = header.filterName;

            // Quanto à direção, se o filtro pretendido já tiver na query,
            // a direção é a contrária à que está na query, senão é asc.
            const direction = ( $route.query.sort === sort )
                ? $route.query.direction === 'asc' ? 'desc' : 'asc'
                : 'asc';

            $router.push({ query: { ...query, sort, direction } });
        };

        /**
         * [method]
         * Verifica se existe alguma ordenação ativa na query do URL
         * nas listagens para determinado campo. Devolve true se o 'sort'
         * tiver na query e false se não tiver.
         *
        */
        const fieldIsInQuery = field => {
            const query = { ...$route.query };

            if ( !query.sort )
                return;

            return query?.sort?.includes( field );
        };

        return {
            orderByColumn,
            fieldIsInQuery,
            helpers
        };
    }
};
</script>

<style lang="scss">
    .sort {
        &__arrow-up {
            margin-left: 30px;
        }
        &__arrow-down {
            margin-left: 10px;
            @include transform( rotate( 180deg ) );
        }
        &__arrow-up, &__arrow-down {
            &--active {
                .arrow, .stick {
                    stroke: #01050B;
                }
            }
        }
    }
</style>